export const getLocalizedBreakoutLabel = (value, language) => {
  if (!value) return '—';
  if (typeof value === 'string') return value;
  if ((language || '').toLowerCase().startsWith('vi')) return value.vi || '—';
  return value.en || '—';
};

export const regimeColor = (r) => {
  if (r === 'RISK_ON') return '#16a34a';
  if (r === 'RISK_OFF') return '#dc2626';
  if (r === 'RECOVERY') return '#0369a1';
  if (r === 'NARROW_RALLY') return '#b45309';
  if (r === 'SIDEWAY') return '#7c3aed';
  return '#64748b';
};

export const isPrepBuySignal = (s) => s === 'BUY_PREP' || s === 'BUY_CAUTION';

export const signalColor = (s) => {
  if (s === 'BUY_PREP') return '#16a34a';
  if (s === 'BUY_CAUTION') return '#b45309';
  if (s === 'BUY_WATCH') return '#2563eb';
  return '#64748b';
};

export const getInvestorGuidanceText = (guidance, language) => {
  if (!guidance) return null;
  const lang = (language || 'vi').startsWith('en') ? 'en' : 'vi';
  return guidance[lang] || guidance.vi || null;
};

export const triggerColor = (triggerType) => {
  if (triggerType === 'BREAKOUT') return '#b45309';
  if (triggerType === 'RETEST') return '#0f766e';
  if (triggerType === 'NEAR_RESISTANCE') return '#64748b';
  if (triggerType === 'SUPPORT_HOLD') return '#1d4ed8';
  return '#64748b';
};
